import * as types from '@/store/mutation-types';
import _ from 'lodash';
import uuid from 'uuid/v4';
import config from '@editor/droplets/droplets.config.json';

const state = {
  showDroplets: false,
  siteDroplets: [],
  puddleFilter: '',
};

const getters = {
  showDroplets(state) {
    return state.showDroplets;
  },
  dropletsTab(state) {
    return state.showDroplets;
  },
  puddleFilter(state) {
    return state.puddleFilter;
  },
  siteDroplets(state) {
    return state.siteDroplets;
  },
};

const mutations = {
  [types.FIRST_DROP_STATUS](state, p) {
    p.drp.firstDrop = false;
  },
  [types.TOGGLE_DROPLETS](state, payload) {
    state.showDroplets = payload;
  },
  [types.SET_PUDDLE_FILTER](state, payload) {
    state.puddleFilter = payload;
  },
  [types.FETCH_DROPLETS](state, payload) {
    state.siteDroplets = [];
    _.forEach(payload.droplets, (type) => {
      const droplet = config[type];
      droplet.name = type;
      state.siteDroplets.push(droplet);
    });
  },
  [types.DROP_NEW_DROPLET](state, p) {
    this._vm.$log.debug('DROP_NEW_DROPLET: ', p);
    // If we're inside a template we need to add a property to the droplet in
    // order to show the locked / unlocked visuals
    if (p.pageType === 'template') {
      p.drp = Object.assign({}, p.drp, { templateRegion: true });
    }
    p.items.splice(p.newIndex, 0, p.drp);
  },
  [types.MOVE_DROPLET](state, p) {
    this._vm.$log.debug('MOVE_DROPLET: ', p);
    const drp = _.cloneDeep(p.sourceItems[p.oldIndex]);
    if (p.sameParent) {
      // rearrange a droplet/item within the same parent
      p.sourceItems.splice(p.newIndex, 0, p.sourceItems.splice(p.oldIndex, 1)[0]);
    } else if (drp) {
      // remove from old parent
      p.sourceItems.splice(p.oldIndex, 1);
      // add to new parent
      p.targetItems.splice(p.newIndex, 0, drp);
    }
  },
};

const actions = {
  async dropNewDroplet({ commit, rootState }, p) {
    p.pageType = rootState.TopControlBar.currentPage.type;
    p.site = rootState.Websites.currentSite;
    if (p.list === 'droplets') {
      const merge = {
        createdDate: new Date().toISOString(),
      };
      if (!p.copy) {
        merge._id = uuid();
      }
      p.drp = Object.assign({}, p.drp, merge);
    }
    commit(types.DROP_NEW_DROPLET, p);
  },
  moveDroplet: ({ commit }, p) => {
    commit(types.MOVE_DROPLET, p);
  },
  firstDropStatus: ({ commit }, payload) => {
    commit(types.FIRST_DROP_STATUS, payload);
  },
  fetchDroplets: ({ commit }, payload) => {
    commit(types.FETCH_DROPLETS, payload);
  },
  setPuddleFilter: ({ commit }, payload) => {
    commit(types.SET_PUDDLE_FILTER, payload);
  },
  toggleDroplets: ({ commit }, payload) => {
    commit(types.TOGGLE_DROPLETS, payload);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/vuex.js